import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';

const NotFoundMC = ({ text }: { text?: string }) => (
  <div className="flex flex-col items-center justify-center max-md:my-10 md:my-20 px-4">
    <div className="text-mc-wattle max-md:text-5xl md:text-[64px] font-semibold">404</div>
    {text ? (
      <h1 className="font-semibold mt-5 text-2xl text-mc-athens-gray max-w-150">{text}</h1>
    ) : (
      <>
        <h1 className="font-semibold mt-5 text-2xl text-mc-athens-gray max-w-150">
          That page doesn&apos;t exist.
        </h1>
        <p className="mt-2 text-mc-santas-gray max-w-150 text-center">
          Head to our home page instead or go search for jobs here
        </p>
      </>
    )}
    <Link
      className="mt-7 h-10 flex items-center w-fit text-center px-12 font-semibold rounded-sm no-underline default-transition text-mc-woodsmoke bg-mc-wattle hover:bg-mc-buttered-rum"
      href={ROUTES.jobs}
    >
      Go to search
    </Link>
  </div>
);

export default NotFoundMC;
